module.exports = __webpack_public_path__ + "static/party-category-aa6bef76ad1c446ec21c36364974a675.png";